import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '../http-error-handler.service';

import { Config } from '../config';
import { DewAuthService } from 'src/authentication/core/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SignUpService {
  private handleError: HandleError;

  private httpOptions = null;
  constructor(
    private http: HttpClient,
    private authService: DewAuthService,
    httpErrorHandler: HttpErrorHandler,
    private sanitizer: DomSanitizer
  ) {
    this.handleError = httpErrorHandler.createHandleError('ApiService');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.authService.authToken,
      }),
    };
  }

  sendOTPMail(email): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/sendOTPMail";
    var request: any = {};
    request.email = email;
    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("sendOTPMail", request)));
  }

  sendOTPSms(requestInput): Observable<any> {
    // console.log(requestInput);
    var url = Config.ServiceBaseUrl + "api/sendOTPSms";
    var request: any = {};
    request.phone = requestInput.phone;
    request.phonePrefixCode = requestInput.phonePrefixCode;
    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("sendOTPSms", request)));
  }

  validateOTPMail(requestInput): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/validateOTPMail";
    var request: any = {};
    request.requestInput = requestInput;
    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("validateOTPMail", request)));
  }

  validateOTPSms(requestInput): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/validateOTPSms";
    var request: any = {};
    request.requestInput = requestInput;
    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("validateOTPSms", request)));
  }
  
  createmasterClientInSignup(masterClientDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/createmasterClientInSignup";
    var request: any = {};
    request = masterClientDetails;

    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("createmasterClientInSignup", request)));
  }
  setMemberPassword(userId ,guid, newpassword): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/setPasswordAnonymous";
    var request: any = {};
    request.userId = userId;
    request.guid = guid;
    request.newpassword = newpassword;
    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("setPasswordAnonymous", request)));
  }


  vaildInviteCheck(userId ,guid): Observable<any> {
    var url = Config.ServiceBaseUrl + "api/vaildInviteCheck";
    var request: any = {};
    request.userId = userId;
    request.guid = guid;
    return this.http
      .post(url, request)
      .pipe(catchError(this.handleError("vaildInviteCheck", request)));
  }
}
